export default "__VITE_ASSET__40b2075d__"